




























































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

export default Vue.extend({
  name: "HolidaysBookingsPrintSticker",
  components: {
    OverlayWindow,
    Loading,
  },
  props: {},
  data() {
    return {
      DateFormatter: DateFormatter,
      detailsTitle: "Namensschilder drucken",
      imageUrl: "" as string,
      imageName: "" as string,
    };
  },
  created() {},
  mounted() {},
  methods: {
    closeDetails() {
      this.$emit("closeOverlay");
    },

    storeBackgroundImage(e: any) {
      if (e.target) {
        let file = e.target.files[0] as File;
        if (file.size > 1024 * 1024 * 10) {
          alert("Die Datei darf maximal 10 MB groß sein. Bitte wählen Sie eine andere Datei aus.");
          return;
        }

        this.imageUrl = URL.createObjectURL(file);
        this.imageName = file.name;
      }
    },

    print() {
      this.$emit("print", this.imageUrl);
    },
  },

  watch: {},

  computed: {},
});
